'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = Paper;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _layout = require('../layout');

var _paper = require('./paper.css');

var _paper2 = _interopRequireDefault(_paper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary This is the kalo paper component.
 * It is in charge of implementing the box-shadow around
 * our cards and the focus/blur animations.
 *
 */
function Paper(props) {
  var _cx;

  var focused = props.focused,
      padded = props.padded,
      _props$border = props.border,
      border = _props$border === undefined ? true : _props$border,
      children = props.children,
      _props$elevation = props.elevation,
      elevation = _props$elevation === undefined ? 1 : _props$elevation,
      _props$hoverElevation = props.hoverElevation,
      hoverElevation = _props$hoverElevation === undefined ? 1 : _props$hoverElevation,
      className = props.className,
      _props$rounded = props.rounded,
      rounded = _props$rounded === undefined ? true : _props$rounded,
      opaque = props.opaque,
      wireframe = props.wireframe,
      onClick = props.onClick,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['focused', 'padded', 'border', 'children', 'elevation', 'hoverElevation', 'className', 'rounded', 'opaque', 'wireframe', 'onClick']);


  var zDepth = Math.min(elevation, 5);
  var hoverZDept = Math.min(hoverElevation, 5);

  var _classNames = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _paper2.default.root, true), (0, _defineProperty3.default)(_cx, _paper2.default.focused, focused), (0, _defineProperty3.default)(_cx, _paper2.default['level-' + zDepth], true), (0, _defineProperty3.default)(_cx, _paper2.default['hover-level-' + hoverZDept], true), (0, _defineProperty3.default)(_cx, _paper2.default.border, border), (0, _defineProperty3.default)(_cx, _paper2.default.rounded, rounded), (0, _defineProperty3.default)(_cx, _paper2.default.padded, padded), (0, _defineProperty3.default)(_cx, _paper2.default.opaque, opaque), (0, _defineProperty3.default)(_cx, _paper2.default.wireframe, wireframe), (0, _defineProperty3.default)(_cx, _paper2.default.interactive, !!onClick), _cx), className);

  return React.createElement(
    _layout.Box,
    (0, _extends3.default)({ className: _classNames, onClick: onClick }, otherProps),
    children
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/paper/paper.js
// module id = 345
// module chunks = 114276838955818